<template>
  <div class="wallet">
    <div class="wallet_balance">
      <div class="balance">
        <span>钱包余额 Wallet balance</span>
        <span>{{ memberData.moneybagBalance || 0 }}</span>
      </div>
      <div class="balance bonus">
        <span>奖励金 Bonus</span>
        <span>{{ memberData.moneybagBonus || 0 }}</span>
      </div>
      <el-button type="primary" class="rules" @click="userRules">使用规则 Rules</el-button>
    </div>
    <div class="runing_water">账户流水 The accounts are running</div>
    <div class="runing_list">
      <el-table :data="flowList" style="width: 100%" :header-cell-style="{ background: '#FCFCFC' }">
        <el-table-column prop="createTime" label="变动时间 Variable time" width="360" align="center"> </el-table-column>
        <el-table-column prop="adjustValue" label="变动金额 Variable amount" width="360" align="center">
        </el-table-column>
        <el-table-column prop="adjustTypeNotag" label="流水类型 Flow type" width="360" align="center">
        </el-table-column>
        <template slot="empty">
          <div class="table-empty">
            <span>暂无数据</span>
            <span>Temporarily no data</span>
          </div>

        </template>
      </el-table>
    </div>
    <TablePage ref="list" @page-change="getAccountsList" :total="total" :pageSizeNum="5"> </TablePage>
    <WalletDialog :visible.sync="WalletVisible" title="使用规则 Rules" :helpList="helpList"></WalletDialog>
  </div>
</template>

<script>
import TablePage from "@/components/base/TablePage";
import WalletDialog from "./components/WalletDialog";
export default {
  name: "order",
  components: { TablePage, WalletDialog },
  data() {
    return {
      memberData: {},
      flowList: [],
      total: 0,
      WalletVisible: false,
      adjustType: {
        1: {name:"小程序充值",nameEn:"Mini Program Recharge"},
        2: {name:"后台充值",nameEn:"Back-end top up"},
        3: {name:"客服调整",nameEn:"Customer Service Adjustments"},
        4: {name:"消费",nameEn:"Consumption"},
      },
      helpList: [
        "1、钱包账户只限在本酒店使用；Wallet accounts can only be used at this hotel;",
        "2、钱包账户不可透支，余额不可提现，也不可转账及退款；The wallet account cannot be overdrafted, the balance cannot be withdrawn, nor can it be transferred or refunded;",
        "3、开票方式根据酒店实际支付金额及岗点决定，赠金部分不能开取发票；The invoicing method is determined according to the actual payment amount of the hotel and the post. Invoices cannot be issued for the bonus part;",
        "4、最终解释权归酒店所有，请联系酒店官方电话进行咨询。The final interpretation right belongs to the hotel, please contact the hotel's official phone for consultation.",
      ],
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.searchHandler();
  },
  methods: {
    // 初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    userRules() {
      this.WalletVisible = true;
    },
    async getAccountsList(page, pageSize) {
      this.memberData = await this.getByUid();
      if (this.memberData.moneybagStatus == 1) {
        this.getFlowList(page, pageSize);
      }
    },
    async getByUid() {
      let obj = await this.$api.getByUid();
      let userinfo = obj.data || {};
      if (userinfo && userinfo.cardGrade) {
        const { data } = await this.$api.getCardListAll();
        let cardIcon;
        let list = data || [];
        for (let i = 0; i < list.length; i++) {
          if (list[i].cardGrade == userinfo.cardGrade) {
            cardIcon = list[i].cardIcon;
            userinfo.memberRightList = (list[i] || []).rightsVOList || {};
          }
        }
        userinfo.cardIcon = cardIcon || "";
      }
      localStorage.setItem("webUserInfo", JSON.stringify(userinfo));
      return userinfo;
    },
    async getFlowList(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getFlowList(params);
        this.flowList = (list || []).map((item) => {
          const adjustType=this.adjustType[item.adjustType]
          item.adjustValue = item.adjustValue > 0 ? "+" + item.adjustValue : item.adjustValue;
          item.adjustTypeNotag = `${adjustType.name} ${adjustType.nameEn}`;
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wallet {
  margin-top: 25px;
  .wallet_balance {
    width: 100%;
    height: 150px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    padding: 40px;
    box-sizing: border-box;
    display: flex;
    align-items: flex-end;
    .balance {
      display: flex;
      flex-direction: column;
      
      color: #333333;
      span:first-child {
        font-size: 14px;
        font-weight: 400;
      }
      span:last-child {
        font-size: 36px;
        font-weight: bold;
        margin-top: 18px;
      }
    }
    .bonus {
      margin-left: 160px;
    }
    .rules {
      width: 152px;
      height: 40px;
      background: #333333;
      font-size: 16px;
      
      font-weight: 400;
      color: #ffffff;
      margin-left: 77px;
    }
  }
  .runing_water {
    font-size: 14px;
    
    font-weight: 400;
    color: #333333;
    margin: 61px 0 18px 0;
  }
  .runing_list {
    width: 1080px;
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
}
</style>
